import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-29",
  "use": "icon-sheet_icon-29-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-29\"><g transform=\"translate(3 2)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\".75\" y=\".75\" width=\"16.5\" height=\"18.5\" rx=\"2\" /><path stroke-linecap=\"round\" d=\"M6 6l3 3M12 6L9 9M6 12.5h6M6 9.5h6M9 9.4v6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol